<script>
import axios from "axios";
import { BrandsPath, GravyPath, RestaurantsPath } from "../../../../../path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import Swal from "sweetalert2";

export default {
  components: { SelectWithSearch },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      base_node_url: process.env.VUE_APP_API_BACKEND_NODE_URL,
      restaurant: null,
      selectedBrands: [],
      brands: [],
      form: {
        gravies: [],
        packagings: [],
        payment_mode: "credit",
        order_type: "online",
        expected_delivery_date: null,
        res_id: null,
      },
    };
  },
  computed: {
    RestaurantsPath() {
      return RestaurantsPath;
    },
  },
  methods: {
    async getBrandKits() {
      try {
        let res = await axios.get(this.baseUrl + BrandsPath.BRAND_KIT, {
          params: {
            "brand_ids[]": this.selectedBrands,
          },
        });
        if (res.data.status) {
          res.data.data.forEach((item) => {
            if (item.gravy_id && item.gravy) {
              item.gravy.qty_to_ship = 1;
              this.form.gravies.push(item.gravy);
            }
          });
          res.data.data.forEach((item) => {
            if (item.packaging_id && item.packaging) {
              item.packaging.qty_to_ship = 1;
              this.form.packagings.push(item.packaging);
            }
          });
        }
        this.saveOrder();
      } catch (e) {
        console.error("Error fetching brand kits:", e);
      }
    },
    async getAllBrands() {
      try {
        let res = await axios.get(this.base_node_url + BrandsPath.GET_BRANDS);

        if (res.data.status) {
          console.log(res.data, "brands");
          this.brands = res.data.brandsList;
        }
      } catch (e) {
        console.error("Error fetching all brands:", e);
      }
    },
    addBrand(id) {
      if (this.selectedBrands.includes(id)) {
        let index = this.selectedBrands.findIndex((b) => b === id);
        this.selectedBrands.splice(index, 1);
      } else {
        this.selectedBrands.push(id);
      }
    },
    selectRestaurant(v) {
      this.form.res_id = v;
    },
    validateData() {
      if (this.form.res_id == null) {
        Swal.fire("Please Select the Restaurant", "", "error");
        return false;
      }
      if (this.selectedBrands.length == 0) {
        Swal.fire("Please Select the Brands", "", "error");
        return false;
      }
      if (this.form.expected_delivery_date == null) {
        Swal.fire("Please Fill Expected Delivery Date", "", "error");
        return false;
      }
      return true;
    },
    async saveOrder() {
      try {
        if (!this.validateData()) {
          return;
        }
        let res = await axios.post(
          this.baseUrl + GravyPath.ORDERS.SAVE,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-brand-kit");
          this.$emit("update");
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getAllBrands();
  },
};
</script>

<template>
  <div>
    <b-row>
      <b-col sm="6">
        <label>Restaurant Partner</label>
        <p v-if="restaurant != null">{{ restaurant.name }}</p>
        <select-with-search
          v-else
          :search_api="RestaurantsPath.GET_RESTAURANTS"
          selected_by="id"
          track_by="id"
          display="name"
          @selectedOption="selectRestaurant"
        ></select-with-search>
      </b-col>
    </b-row>
    <b-row
      class="mt-4"
      style="
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 15px;
        padding-inline: 10px;
      "
    >
      <template v-for="brand in brands">
        <b-card
          :key="brand.name"
          :style="{
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: 'rgb(230, 230, 230)',
            border: selectedBrands.includes(brand.id) ? '3px solid green' : '',
          }"
        >
          <img
            :src="brand.image_url"
            :alt="brand.name"
            @click="addBrand(brand.id)"
            width="150px"
            height="150px"
            style="object-fit: fill"
            class="brand-hover"
          />
        </b-card>
      </template>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="9" md="6">
        <label>Expected Delivery</label>
        <b-form-datepicker
          v-model="form.expected_delivery_date"
        ></b-form-datepicker>
      </b-col>
      <b-col class="d-flex justify-content-end" style="align-self: end">
        <b-button variant="success" size="lg" @click="getBrandKits()">
          Add Brand Kit
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.brand-hover {
  transition: transform 0.3s ease-in-out;
}

.brand-hover:hover {
  transform: scale(1.1);
}
</style>
